module.exports = __webpack_public_path__ + "img/bg.97213314.jpg";